import React from "react";
import ButtonComp from "./ButtonComp";
import TickCircle from "../../assets/images/public-pages/tick-circle.svg"
import GoldIcon from "../../assets/images/public-pages/gold-icon.svg"

const ContentPriceSection = ({
  contentSection,
  quoteText,
  paragraphs = [],
  listSectionTitle,
  listColumns = [],
  listSingleColumn = false,
  btnLink,
  btnText,
  btnClassName,
  reverse = false,
  listBottomText,
  showCard = false,
  cardTitle,
  cardSubtitle,
  cardPrice,
  cardFeatures = [],
  cardBtnText,
  cardBtnLink
}) => {
  return (
    <div className={`justify-content-between gap-3 row content-price-section ${reverse ? "flex-row-reverse" : ""}`}>
      {/* LEFT CONTENT */}
      <div className="col-lg-5 col-md-12 mb-lg-0">
        {/* {(highlightText || title) && (
          <h1 className="hero-title">
            {highlightText && <span className="text-success FS40FW600">{highlightText}</span>}
            {highlightText && title && <br />}
            {title}
          </h1>
        )} */}
        {contentSection && contentSection()}
        {quoteText && (
          <div
            className="mt-3 black"
            dangerouslySetInnerHTML={{ __html: quoteText }}
          />
        )}

        {paragraphs.map((text, i) => (
          <p key={i} className="mt-3 FS17FW500 quote-para" dangerouslySetInnerHTML={{ __html: text }} />
        ))}

        {listColumns.length > 0 && (
          <>
            {listSectionTitle && <p className="mt-3 FS17FW500 quote-para">{listSectionTitle}</p>}
            <div className={`cis-list-columns quote-list ${listSingleColumn ? "cis-list-single" : "d-flex gap-3"}`}>
              {listColumns.map((col, i) => (
                <ul key={i} className="feature-list">
                  {col.map((item, j) => (
                    <li key={j} className="FS16FW500 fw-normal">{item}</li>
                  ))}
                </ul>
              ))}
            </div>
          </>
        )}
        {listBottomText && (
          <span className="quote-para FS17FW500">{listBottomText}</span>
        )}
        {btnLink && btnText && (
          <ButtonComp link={btnLink} btnText={btnText} className={btnClassName} />
        )}
      </div>

      {/* RIGHT IMAGE / CARD */}
      <div className="col-lg-6 col-md-12">
        {showCard ? (
          <div className="price-card">
            <div className="card-top">
              <div className="card-title-area">
                <h3 className="card-main-title">{cardTitle}</h3>
                <p className="card-subtitle">{cardSubtitle}</p>
              </div>
              <div className="price-area">
                <div className="starting-price">
                  <span>Starting Price</span>
                  <img src={GoldIcon} alt="Price" />
                </div>
                <div className="price-text">${cardPrice}</div>
              </div>
            </div>

            <div className="card-features-grid">
              {cardFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  <img src={TickCircle} alt="tick" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>

            {cardBtnText && (
              <ButtonComp 
                link={cardBtnLink || "#"} 
                btnText={cardBtnText} 
                className="card-bottom-btn" 
              />
            )}
          </div>
        ) : (
          <div className="right-image-placeholder">
            {/* You can add an image here if showCard is false */}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContentPriceSection;
